var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 76.9 76.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2,.cls-3{fill:none;}.cls-2{stroke:#fff;stroke-miterlimit:10;stroke-width:0.9px;}.cls-3{stroke:#018b9d;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.08px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Star") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 38.45,
    cy: 38.45,
    r: 32.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 38.45,
    cy: 38.45,
    r: 38
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "38.45 46.9 24.98 57 30.37 40.84 18.25 31.41 33.06 31.41 38.45 15.92 43.84 31.41 58.66 31.41 46.53 40.84 51.92 57 38.45 46.9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.f9bc10decf23f8c651b4b198872cef0d.svg";
export { ForwardRef as ReactComponent };